const Dark = () => (
  <>
    <path
      fill="currentColor"
      d="M12.5 19.58q-3.332 0-5.666-2.333T4.5 11.581q0-2.469 1.414-4.536t4.009-2.972q.306-.107.537-.057.23.05.38.2a.7.7 0 0 1 .192.38.9.9 0 0 1-.063.489q-.195.477-.281.966a6 6 0 0 0-.088 1.03q0 2.667 1.867 4.533T17 13.481q.697 0 1.278-.148.58-.15.987-.24a.9.9 0 0 1 .4.01.57.57 0 0 1 .288.176.65.65 0 0 1 .16.308.73.73 0 0 1-.048.417q-.715 2.45-2.803 4.013-2.087 1.564-4.762 1.564m0-1q2.2 0 3.95-1.212A7 7 0 0 0 19 14.206q-.5.125-1 .2t-1 .075q-3.075 0-5.238-2.163Q9.6 10.156 9.6 7.081q0-.5.075-1t.2-1a7 7 0 0 0-3.162 2.55Q5.5 9.38 5.5 11.58q0 2.9 2.05 4.95t4.95 2.05"
    />
  </>
)
export default Dark
